import { Guid } from "@/types"

export interface IOverheadFactorDto {
    assetTypeId?: Guid | null
    assetTypeName?: string
    overheadWarranty: number
    overheadAdministration: number
    overheadSales: number
    assetCategoryId?: Guid
    divisionId?: Guid
}

export default class OverheadFactor {
    assetTypeId?: Guid
    assetTypeName?: string
    overheadWarranty: number
    overheadAdministration: number
    overheadSales: number
    assetCategoryId?:Guid
    divisionId?:Guid

    constructor(dto: IOverheadFactorDto) {
        this.assetTypeId = dto.assetTypeId ?? undefined
        this.assetTypeName = dto.assetTypeName ?? undefined
        this.overheadWarranty = dto.overheadWarranty
        this.overheadAdministration = dto.overheadAdministration
        this.overheadSales = dto.overheadSales
        this.assetCategoryId= dto.assetCategoryId
        this.divisionId =dto.divisionId
    }
}
